import { COUNTRIES } from '@modules/settings/my-numbers/purchase-number/constants/purchase-number.constant';
import { AvatarSourceParams } from '@shared/types/utils/avatar.types';
import { generateAvatar } from '@shared/utils';
import { getCountryCodeByPhoneNumber } from './country.helper';

export const getAvatarSource = ({ avatarPreview, contactDetails, phoneNumber }: AvatarSourceParams) => {
  if (avatarPreview) return avatarPreview;

  if (contactDetails?.profilePicture?.url) return contactDetails.profilePicture.url;
  if (contactDetails?.country?.flag) return contactDetails.country.flag;

  // TO-DO: replace the COUNTRIES constant with countries list api

  phoneNumber = phoneNumber || contactDetails?.phoneNumber;
  if (phoneNumber) {
    phoneNumber = phoneNumber.replaceAll(' ', '');
    const countryCode = getCountryCodeByPhoneNumber(phoneNumber);
    const countryFlag = COUNTRIES.find((country) => country.alphaTwoCode === countryCode)?.flagUrl;
    if (countryFlag) return countryFlag;
  }
  if (contactDetails?.name) return generateAvatar(contactDetails?.name?.toString());
  return undefined;
};

export type GetAvatarProps = {
  profilePicture?: string | null;
  name?: string | null;
  phoneNumber?: string | null;
};

export const getAvatar = ({ profilePicture, name, phoneNumber }: GetAvatarProps) => {
  if (profilePicture) return getAvatarSource({ avatarPreview: profilePicture });
  if (name) return getAvatarSource({ contactDetails: { name: name } });
  if (phoneNumber) return getAvatarSource({ phoneNumber: phoneNumber });
  return getAvatarSource({ contactDetails: { name: 'Calilio' } });
};
